import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";

export default {
  path: "/background-image",
  redirect: "/background-image",
  name: "BackgroundImage",
  component: LAYOUT,
  meta: {
    order: 30,
    title: "背景图片管理",
  },
  children: [
    {
      path: "",
      name: "BackgroundImagePage",
      component: () =>
        import("../../views/backgroundImage/BackgroundImagePage.vue"),
      meta: {
        title: "背景图片管理",
        icon: "background",
      },
    },
  ],
} as RouteRecordRaw;
